module.exports = __webpack_public_path__ + "assets/img/returnBtn-df785031.png";